import { Type } from '@angular/core';
import { ProductMenu } from '../product-menu';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { Section } from '../section/section';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { ColumnUtils } from '../../../utils/column-utils';
import { ColumnGrouping } from '../section/column-grouping';
import { StrainType } from '../../enum/dto/strain-classification.enum';
import { SectionLayoutType } from '../../enum/dto/section-layout-type.enum';
import { StringUtils } from '../../../utils/string-utils';
import { SortVariantUtils } from '../../../utils/sort-variant-utils';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from 'src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class LobsterButterMenu extends ProductMenu {
  getThemeClass(): string {
    return 'lobster-butter-theme';
  }

  getHeaderType(): Type<MenuHeaderTitleImageComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getShowFooter(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.StrainType, 1],
      [SectionColumnProductInfoType.ProductTitle, 2],
      [SectionColumnProductInfoType.Badge, 3],
      [SectionColumnProductInfoType.Brand, 4],
      [SectionColumnProductInfoType.Strain, 5],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(6),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(7),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(8),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(9),
      [SectionColumnProductInfoType.QuantityAndSize, 10],
      [SectionColumnProductInfoType.Quantity, 11],
      [SectionColumnProductInfoType.Size, 12],
      [SectionColumnProductInfoType.VariantType, 13],
      [SectionColumnProductInfoType.Stock, 14],
      [SectionColumnProductInfoType.GradingResults, 15],
      [SectionColumnProductInfoType.VariantPrice, 16],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 17]
    ]);
  }

  getShouldInflateColumnHeaderForRow(s: Section, col: SectionColumnViewModel, rows: SectionRowViewModel[]): boolean {
    const classification = col?.columnType === SectionColumnProductInfoType.StrainType;
    return !classification;
  }

  getUniqueClassificationList(): StrainType[] {
    return super.getUniqueClassificationList()?.sort(SortVariantUtils.genericStrainTypeSort);
  }

  getPriceColumnTitle(col: SectionColumnViewModel): string {
    const title = super.getPriceColumnTitle(col);
    return col.sectionLayoutType !== SectionLayoutType.List ? StringUtils.removeWhiteSpace(title) : title;
  }

  getLineModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  getGridModeColumnGroupings(sectionColumnViewModels: SectionColumnViewModel[]): ColumnGrouping[] {
    return ColumnUtils.oneBigGrouping();
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Roboto.Regular_400,
      FONT.Roboto.Medium_500,
      FONT.Roboto.Black_900,
      FONT.MerriWeather.Bold_700,
      FONT.MerriWeather.Black_900
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/ldb5dmn.css';
  }
}
